import type { ValuesType } from 'utility-types';

import type { CasinoPlayerGames, CasinoServiceParameters } from '@swf/cms';
import type { MarketingTag } from '@swf/core/types/CasinoGame';
import type { WidgetReference } from '@swf/core/types/Widget';

export interface CasinoWidget extends WidgetReference {
  game_service?: string;
  params?: CasinoServiceParameters;
  hide_on_login?: boolean;
  logged_in_only?: boolean;
}

export type CasinoIcon = NonNullable<ValuesType<CasinoServiceParameters['ims']['icon_tags']>>;
export type MosaicLayout = CasinoPlayerGames['mosaic_layout'];
export type IncludeTags = string[];

export enum RenderNames {
  minBet = 'minBet',
  maxBet = 'maxBet',
  returnToPlayer = 'returnToPlayer',
  paylines = 'paylines',
  features = 'features'
}

export type FeatureVariant = 'standard' | 'no-bottom' | 'mini-detail' | 'persistent-info';

export type MarketingIcon = MarketingTag.New | MarketingTag.Exclusive;

export type CasinoGameService =
  | 'casino.games.all.stream'
  | 'casino.games.recent.stream'
  | 'casino.games.recommended.stream'
  | 'casino.games.myfsb'
  | 'casino.games.playergames'
  | 'casino.live.games.stream'
  | '/api/v1-preview/casino/games/rapid/stream';

export enum CasinoSection {
  OneBigSquare = '1 big square',
  FourSquares = '4 squares',
  OneTopTwoBottom = '1 top 2 bottom',
  TwoTopOneBottom = '2 top 1 bottom',
  OneTopOneBottom = '1 top 1 bottom'
}

export * from './races';
